


<div>

   <div *ngIf="windowWidth > 992; else elseTemplate">
    <app-header></app-header>
   <app-header-two></app-header-two>
  </div>

  <ng-template #elseTemplate>
    <ima-header-mobile-theme1></ima-header-mobile-theme1>
  </ng-template>

</div>


<!-- quick cart -->
<app-quick-cart-theme1></app-quick-cart-theme1>

<!-- branches modal -->
<app-branches-modal></app-branches-modal>
